import {selectDropdownItem} from '%helpers%/helpers';
import EventHandler from 'bootstrap/js/src/dom/event-handler';
import Swiper from 'swiper/bundle';

export const initiateWidgetTabs = widget => {
  if (!widget) return;

  const dropdownSelect = widget.querySelector('.dropdown-select');
  const closestScrollEl = widget.closest('.modal') || window;
  const closestWidgetWrapper = widget.closest('.widget-tabs_block') || widget.closest('.widget-wrapper');
  const closestSection = widget.closest('section.widget-wrapper');
  const header = document.querySelector('.page-header');

  const {
    bsAutoScrollLocked = false,
    bsAutoScroll = false,
    bsAutoScrollLoad = false,
    bsOffsetTop = 0,
  } = widget.dataset || {};

  const getOffsetTop = el => {
    let top = 0;

    if (closestWidgetWrapper) {
      top += closestWidgetWrapper.offsetTop || 0;
      top += closestWidgetWrapper.offsetParent?.offsetTop || 0;
    } else {
      top += widget.offsetTop || 0;
      top += widget.offsetParent?.offsetTop || 0;
    }

    if (
      closestWidgetWrapper?.classList.contains('widget-wrapper') &&
      closestWidgetWrapper.classList.contains('sticky-top')
    ) {
      const {bsTarget} = el.dataset;
      const targetEl = bsTarget && document.querySelector(bsTarget);
      if (targetEl) {
        top = targetEl.offsetTop - el.offsetHeight;
      }
    }

    return top;
  };

  const scrollTop = el => {
    let top = getOffsetTop(el);

    if (el.closest('.widget-vertical-tabs') && closestSection) {
      const prev = closestSection.previousElementSibling;
      if (prev?.querySelector('.widget-heading')) {
        top -= prev.offsetHeight;
      }
    }

    const scrollPos = closestScrollEl === window ? window.scrollY : closestScrollEl.scrollTop;

    if (!bsAutoScrollLocked && (scrollPos > top || bsAutoScroll || bsAutoScrollLoad)) {
      closestScrollEl.scrollTo({
        top: top - (header?.offsetHeight || 0) - bsOffsetTop,
        behavior: 'smooth',
      });
    }
  };

  widget.querySelectorAll('[data-bs-toggle="tab"], [data-bs-toggle="pill"]').forEach(el => {
    el.addEventListener('shown.bs.tab', () => {
      scrollTop(el);
    });
  });

  if (dropdownSelect) {
    EventHandler.on(widget, 'shown.bs.tab', '[data-bs-toggle="tab"]', ({target, relatedTarget}) => {
      const {category, bsTarget} = target.dataset;

      if (category) {
        widget
          .querySelectorAll(`button[data-bs-toggle="tab"][data-category="${category}"]`)
          .forEach(el => el.classList.add('active'));

        if (relatedTarget?.dataset.category) {
          widget
            .querySelectorAll(
              `button[data-bs-toggle="tab"][data-category="${relatedTarget.dataset.category}"]`
            )
            .forEach(el => el.classList.remove('active'));
        }

        const dropdownBtn = dropdownSelect.querySelector(
          `button[data-bs-toggle="tab"][data-category="${category}"]`
        );
        if (dropdownBtn) selectDropdownItem(dropdownBtn);
      } else if (bsTarget) {
        widget
          .querySelectorAll(`button[data-bs-toggle="tab"][data-bs-target="${bsTarget}"]`)
          .forEach(el => el.classList.add('active'));

        if (relatedTarget?.dataset.bsTarget) {
          widget
            .querySelectorAll(
              `button[data-bs-toggle="tab"][data-bs-target="${relatedTarget.dataset.bsTarget}"]`
            )
            .forEach(el => el.classList.remove('active'));
        }

        const dropdownBtn = dropdownSelect.querySelector(
          `button[data-bs-toggle="tab"][data-bs-target="${bsTarget}"]`
        );
        if (dropdownBtn) selectDropdownItem(dropdownBtn);
      }
    });
  }

  if (widget.querySelector('.swiper')) {
    initiateSwiperTabsWidget(widget);
  }
};

function initiateSwiperTabsWidget(widget) {
  const swiperEl = widget.querySelector('.swiper');
  if (!swiperEl) return;

  const swiperBtnNext = widget.querySelector('.swiper-btn-next');
  const swiperBtnPrev = widget.querySelector('.swiper-btn-prev');

  const getSlides = () => Array.from(widget.querySelectorAll('.swiper-slide'));

  const setClassNames = swiper => {
    const slides = getSlides();
    const slidesPerView = swiper.params.slidesPerView;
    widget.classList.toggle('with-slidesPerView-auto', slidesPerView === 'auto');
    widget.classList.toggle(
      'with-arrows-hidden',
      (slidesPerView !== 'auto' && slides.length <= slidesPerView) ||
        slides.every(slide => slide.classList.contains('swiper-slide-fully-visible'))
    );
  };

  const checkFullyVisibleSlide = (swiper, slide) => {
    if (!slide) return;
    const slides = getSlides();
    const slidesPerView = swiper.params.slidesPerView;
    if (!slide.classList.contains('swiper-slide-fully-visible') && slidesPerView !== slides.length) {
      const index = slides.indexOf(slide);
      if (index > -1) swiper.slideTo(index);
    }
  };

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 'auto',
    speed: 600,
    mousewheel: true,
    slideToClickedSlide: true,
    watchSlidesProgress: true,
    freeMode: true,
    navigation: {
      nextEl:
        swiperBtnNext ||
        (widget.id && document.querySelector(`.swiper-btn-next[data-bs-target="#${widget.id}"]`)),
      prevEl:
        swiperBtnPrev ||
        (widget.id && document.querySelector(`.swiper-btn-prev[data-bs-target="#${widget.id}"]`)),
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 4,
      },
    },
    on: {
      init(swiper) {
        widget.classList.add('is-swiper-initialized');
        requestAnimationFrame(() => setClassNames(swiper));
      },
      breakpoint(swiper) {
        swiper.update();
        requestAnimationFrame(() => {
          setClassNames(swiper);
          const activeSlide = widget.querySelector('.nav-link.active')?.closest('.swiper-slide');
          checkFullyVisibleSlide(swiper, activeSlide);
        });
      },
      slideChange(swiper) {
        if (swiper.params.slidesPerView === 1) {
          const activeBtn = swiperEl.querySelectorAll('.swiper-slide .nav-link')[swiper.activeIndex];
          if (activeBtn) bootstrap.Tab.getOrCreateInstance(activeBtn).show();
          checkFullyVisibleSlide(swiper, activeBtn?.closest('.swiper-slide'));
        }
      },
    },
  });

  widget.addEventListener('shown.bs.tab', e => {
    const slides = getSlides();
    const slide = e.target.closest('.swiper-slide');
    if (!slide) return;
    const index = slides.indexOf(slide);
    if (index > -1 && swiper.realIndex !== index) swiper.slideTo(index);
  });

  swiperEl.closest('.modal')?.addEventListener('shown.bs.modal', () => {
    swiper.update();
  });

  return swiper;
}
